import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useUnreadCount } from "@/lib/api/shareable-entities";
import { useGetChannelMentorship } from "@/lib/hooks/conversations/use-get-channel-mentorship";
import { cn } from "@/lib/utils";
import { useHubStore } from "./use-hub-store";
import { usePostHogEvent } from "@/lib/posthog";
import { useFeatureFlagEnabled } from "@posthog/react";
import { useAbility } from "@/lib/casl/ability-context";
import { LayoutGrid } from "lucide-react";

export function HubTrigger() {
  const ability = useAbility();
  const isOpen = useHubStore((state) => state.isOpen);
  const toggle = useHubStore((state) => state.toggle);
  const { mentorship } = useGetChannelMentorship();
  const { dispatchEvent } = usePostHogEvent("mentor_hub", { onMount: false });
  const isMomentsFlag = useFeatureFlagEnabled("enable-moments");
  const isSwapsFlag = useFeatureFlagEnabled("enable-swaps");
  const isMomentsEnabled = isMomentsFlag === true;
  const isSwapsEnabled = isSwapsFlag === true;

  // Exclude moments/swaps from count if feature flag is explicitly false
  const excludeTypes = [
    ...(!isMomentsEnabled ? ["moment"] : []),
    ...(!isSwapsEnabled ? ["swap"] : []),
  ];

  const { data: unreadCount = 0 } = useUnreadCount(
    mentorship?.mentee?.id,
    excludeTypes.length > 0 ? excludeTypes : undefined
  );

  if (!ability.can("read", "shareable-entities")) return null;

  const handleToggle = () => {
    if (isOpen) {
      dispatchEvent("mentor_hub_closed");
    } else {
      dispatchEvent("mentor_hub_opened");
    }
    toggle();
  };

  return (
    <Button
      variant="outline"
      className={cn("ml-2 gap-2", isOpen ? "bg-[#E2E2E2]" : "bg-white")}
      onClick={handleToggle}
    >
      <LayoutGrid className="h-4 w-4" />
      Hub
      {unreadCount > 0 && (
        <Badge variant="outline" className="text-xs">
          {unreadCount}
        </Badge>
      )}
    </Button>
  );
}
